import { useEffect, useState } from "react";

import type { DevelopmentProjectSlug } from "@/config/constants";
import {
  watchDevelopmentProjects,
  watchDevelopmentUpdates,
} from "@/data/developmentProjects.repo";
import type { DevelopmentProject, DevelopmentUpdate } from "@/data/types";
import { readCache, writeCache } from "@/lib/cache";

const KEY_PROJECTS = "jmd:developmentProjects";
const KEY_UPDATES = (slug: string) => `jmd:developmentUpdates:${slug}`;

export function useDevelopmentProjects(): DevelopmentProject[] {
  const [items, setItems] = useState<DevelopmentProject[]>(() =>
    readCache<DevelopmentProject[]>(KEY_PROJECTS, []),
  );
  useEffect(() => {
    return watchDevelopmentProjects((v) => {
      setItems(v);
      writeCache(KEY_PROJECTS, v);
    });
  }, []);
  return items;
}

export function useDevelopmentUpdates(slug: DevelopmentProjectSlug): DevelopmentUpdate[] {
  const [items, setItems] = useState<DevelopmentUpdate[]>(() =>
    readCache<DevelopmentUpdate[]>(KEY_UPDATES(slug), []),
  );
  useEffect(() => {
    return watchDevelopmentUpdates(slug, (v) => {
      setItems(v);
      writeCache(KEY_UPDATES(slug), v);
    });
  }, [slug]);
  return items;
}
